import NotFound from '../../../scenes/common/NotFound';
import Start from '../../../scenes/common/Start';
import { IRoute } from '../IRoute';

const CommonRoutes: IRoute[] = [
  {
    component: NotFound,
    default: true,
    key: '/404',
    path: '/404'
  },
  {
    component: Start,
    key: '/',
    path: '/',
    scope: 'guest'
  },
  {
    component: Start,
    key: '/start',
    path: '/start',
    scope: 'guest'
  }
];

export default CommonRoutes;
